<span class="pill" [ngClass]="pillClass()">
  @if (companyLogo(); as companyLogo) {
    <img [ngSrc]="companyLogo" alt="company logo" height="22" width="22">
  }
  <span class="text">{{ companyName() }}</span>
</span>
